module.exports = __webpack_public_path__ + "img/chain_industry-solution7.1f314802.png";